import { Link } from "react-router-dom";
import MovieCard from "@/components/base/MovieCard";
import { getMoviesByCategory } from "@/mocks/movies";

export default function DramaSection() {
  const dramas = getMoviesByCategory("dianshiju").slice(0, 6);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-5 md:mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            热播电视剧
          </h2>
          <p className="text-sm text-foreground-500 mt-1">好剧连播，追剧不停歇</p>
        </div>
        <Link
          to="/category/dianshiju"
          className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
        >
          全部电视剧 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 md:gap-5" data-product-shop>
        {dramas.map((movie) => (
          <MovieCard
            key={movie.id}
            id={movie.id}
            title={movie.title}
            image={movie.image}
            rating={movie.rating}
            category={movie.category}
            year={movie.year}
            isNew={movie.isNew}
          />
        ))}
      </div>
    </section>
  );
}